import * as React from "react";
import { AppPageWrapper } from "@talentpair/quantic";
import type { TalentpairAssistantChatProps } from "./TalentpairAssistantChat";

const page = React.lazy(() => import("./TalentpairAssistantChat"));
const TalentpairAssistantChat = (props: TalentpairAssistantChatProps): React.ReactElement => (
  <AppPageWrapper page={page} {...props} />
);
export default TalentpairAssistantChat;
